// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Barra global de ruta de navegación (breadcrumbs + historial).
 * Vive justo debajo de la barra superior y por encima del contenido, así que
 * los overlays de detalle arrancan por debajo de ella (ver DetailView.css).
 */

.crumb-bar {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex: none;
  height: var(--app-crumb-h, 42px);
  box-sizing: border-box;
  margin-left: 240px;
  width: calc(100% - 240px);
  padding: 0 1.25rem;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border);
  transition: margin-left 0.25s ease, width 0.25s ease;
}

/* ── Botones de historial ── */
.crumb-nav-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex: none;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.crumb-nav-btn svg {
  width: 16px;
  height: 16px;
}

.crumb-nav-btn:hover:not(:disabled) {
  background: var(--bg-toolbar);
  color: var(--text-primary);
}

.crumb-nav-btn:disabled {
  opacity: 0.3;
  cursor: default;
}

.crumb-nav-btn:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 1px;
}

.crumb-divider {
  flex: none;
  width: 1px;
  height: 18px;
  margin: 0 0.5rem;
  background: var(--border);
}

/* ── Migas ── */
.crumb-trail {
  display: flex;
  align-items: center;
  gap: 0.15rem;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  font-size: 0.82rem;
  line-height: 1;
  scrollbar-width: none;
}

.crumb-trail::-webkit-scrollbar {
  display: none;
}

.crumb-link,
.crumb-muted,
.crumb-current {
  display: inline-block;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0.28rem 0.4rem;
  border-radius: 4px;
}

.crumb-link {
  color: var(--text-secondary);
  text-decoration: none;
}

.crumb-link:hover {
  color: var(--accent-l);
  background: var(--bg-toolbar);
  text-decoration: none;
}

.crumb-link:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: -2px;
}

.crumb-muted {
  color: var(--text-muted);
}

.crumb-current {
  color: var(--text-primary);
  font-weight: 600;
}

.crumb-sep {
  flex: none;
  width: 11px;
  height: 11px;
  color: var(--text-muted);
  opacity: 0.75;
}

/* ── Responsive ── */
@media (max-width: 992px) {
  .crumb-bar {
    margin-left: 0;
    width: 100%;
    padding: 0 0.75rem;
  }

  .crumb-link,
  .crumb-muted,
  .crumb-current {
    max-width: 150px;
  }
}

@media print {
  .crumb-bar {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Breadcrumbs.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,gCAAgC;EAChC,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,sCAAsC;EACtC,oDAAoD;AACtD;;AAEA,+BAA+B;AAC/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;EACpB;;EAEA;;;IAGE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/**\r\n * Barra global de ruta de navegación (breadcrumbs + historial).\r\n * Vive justo debajo de la barra superior y por encima del contenido, así que\r\n * los overlays de detalle arrancan por debajo de ella (ver DetailView.css).\r\n */\r\n\r\n.crumb-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n  flex: none;\r\n  height: var(--app-crumb-h, 42px);\r\n  box-sizing: border-box;\r\n  margin-left: 240px;\r\n  width: calc(100% - 240px);\r\n  padding: 0 1.25rem;\r\n  background: var(--bg-card);\r\n  border-bottom: 1px solid var(--border);\r\n  transition: margin-left 0.25s ease, width 0.25s ease;\r\n}\r\n\r\n/* ── Botones de historial ── */\r\n.crumb-nav-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 28px;\r\n  height: 28px;\r\n  flex: none;\r\n  padding: 0;\r\n  border: 1px solid transparent;\r\n  border-radius: 6px;\r\n  background: transparent;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  transition: background-color 0.15s ease, color 0.15s ease;\r\n}\r\n\r\n.crumb-nav-btn svg {\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n\r\n.crumb-nav-btn:hover:not(:disabled) {\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.crumb-nav-btn:disabled {\r\n  opacity: 0.3;\r\n  cursor: default;\r\n}\r\n\r\n.crumb-nav-btn:focus-visible {\r\n  outline: 2px solid var(--accent);\r\n  outline-offset: 1px;\r\n}\r\n\r\n.crumb-divider {\r\n  flex: none;\r\n  width: 1px;\r\n  height: 18px;\r\n  margin: 0 0.5rem;\r\n  background: var(--border);\r\n}\r\n\r\n/* ── Migas ── */\r\n.crumb-trail {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.15rem;\r\n  min-width: 0;\r\n  overflow-x: auto;\r\n  overflow-y: hidden;\r\n  white-space: nowrap;\r\n  font-size: 0.82rem;\r\n  line-height: 1;\r\n  scrollbar-width: none;\r\n}\r\n\r\n.crumb-trail::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.crumb-link,\r\n.crumb-muted,\r\n.crumb-current {\r\n  display: inline-block;\r\n  max-width: 260px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  padding: 0.28rem 0.4rem;\r\n  border-radius: 4px;\r\n}\r\n\r\n.crumb-link {\r\n  color: var(--text-secondary);\r\n  text-decoration: none;\r\n}\r\n\r\n.crumb-link:hover {\r\n  color: var(--accent-l);\r\n  background: var(--bg-toolbar);\r\n  text-decoration: none;\r\n}\r\n\r\n.crumb-link:focus-visible {\r\n  outline: 2px solid var(--accent);\r\n  outline-offset: -2px;\r\n}\r\n\r\n.crumb-muted {\r\n  color: var(--text-muted);\r\n}\r\n\r\n.crumb-current {\r\n  color: var(--text-primary);\r\n  font-weight: 600;\r\n}\r\n\r\n.crumb-sep {\r\n  flex: none;\r\n  width: 11px;\r\n  height: 11px;\r\n  color: var(--text-muted);\r\n  opacity: 0.75;\r\n}\r\n\r\n/* ── Responsive ── */\r\n@media (max-width: 992px) {\r\n  .crumb-bar {\r\n    margin-left: 0;\r\n    width: 100%;\r\n    padding: 0 0.75rem;\r\n  }\r\n\r\n  .crumb-link,\r\n  .crumb-muted,\r\n  .crumb-current {\r\n    max-width: 150px;\r\n  }\r\n}\r\n\r\n@media print {\r\n  .crumb-bar {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
